import React, { Component } from "react";

import { Form, Button, Input, Card, message } from "antd";

import api from "../../../../services/api";
import handleError from "../../../../services/apiErrorHandler";
import 'antd/dist/antd.css';
const { TextArea } = Input;

export default class Cadastro extends React.Component {


    handleOnSubmit = async (e) => {
        e.preventDefault();
        const { form } = this.props;
        const params = {
            user: localStorage.auth_userid,
            texto: form.getFieldValue('texto')
        }

        try {
            const res = await api.post('/sms/modelo_sms/', params)
            message.success('SMS Cadastrado com sucesso!');
            form.resetFields()
        } catch (err) {
            console.log(err)
            message.error('Ocorreu um erro!');
        }
    }


    render() {
        const { getFieldDecorator } = this.props.form
        return (
            <React.Fragment>
                <br />
                <Card title="Cadastro de SMS Pré definido">
                    Aqui você pode cadastrar sms que os operadores poderão usar.
                    <br /><br />
                    Temos disponíveis as seguintes variáveis para serem usadas:
                    <br />
                    <ul>
                        <li>{"Pasta {pasta}"}</li>
                        <li>{"Valor de Ressarcimento {vlr_ressarcimento}"}</li>
                        <li>{"Número do Sinistro {num_sinistro}"}</li>
                        <li>{"Nome do Condutor {cond_nome}"}</li>
                        <li>{"Nome do Proprietário {prop_nome}"}</li>
                        <li>{"Nome {any_nome} (Aqui o nome usaro será o do condutor. Caso não tenha, será usado o do proprietário)"}</li>
                    </ul>

                    Para a variável funcionar, é necessário colocar as chaves {"\"{}\""}<br /><br />

                    Exemplo: {"Prezado {any_nome}. Favor entrar em contato para falar da sua dívida de {vlr_ressarcimento}. Ref {pasta}."}

                </Card>
                <br />
                <Card>
                    <Form onSubmit={this.handleOnSubmit}>
                        <Form.Item label="Texto">
                            {getFieldDecorator('texto', {
                                rules: [{ required: true, message: 'Digite a mensagem' }]
                            })(
                                <TextArea />
                            )}
                        </Form.Item>
                        <Button htmlType="submit" type="primary">Salvar</Button>
                    </Form>
                </Card>
            </React.Fragment >
        )
    }

}



export const CadastroForm = Form.create({ name: 'cadastro_form' })(Cadastro);


// WEBPACK FOOTER //
// ./src/pages/Sms/Cadastro/components/cadastro_form.js